import React from "react";
import { Form, Row, Col, Input, DatePicker, Space, Button } from "antd";
const { RangePicker } = DatePicker;
function Search() {
  const handleFormSubmit = () => {};

  const [form] = Form.useForm();

  const onClear = () => {};
  return (
    <>
      <Form
        form={form}
        onFinish={handleFormSubmit}
        layout="vertical"
        className="search-form"
        initialValues={{ receiptType: { name: "LOCAL", value: "LOCAL" } }}
      >
        <Row gutter={24}>
          <Col span={5}>
            <Form.Item label="Cus.Dec.No#">
              <Input />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item label="Delivery No#">
              <Input />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item label="Date Range">
              <RangePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item label="Voucher number">
              <Input />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Space
              direction="horizontal"
              align="center"
              className={"search-cancel-buttons-space"}
            >
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{ margin: "0 8px" }}
                onClick={() => {
                  form.resetFields();
                  onClear();
                }}
              >
                Clear
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default Search;
